import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions, TabbedItem, TabPanelOptions, Tab
} from 'devextreme-react/form';
import { Solicitar, Insertar, Modificar } from "../../Hooks/PeticiondeRegistros";
import ComboAbmConCuentasFinancieras from "../Compuestos/Combos/ComboAbmConCuentasFinancieras";
import ComboAbmEexProfesionalesTipos from "../Compuestos/Combos/ComboAbmEexProfesionalesTipos";
import ComboAbmEexProveedores from "../Compuestos/Combos/ComboAbmEexProveedores";
import ComboAbmEexPersonas from "../Compuestos/Combos/ComboAbmEexPersonas";
import ComboAbmGeoCiudades from "../Compuestos/Combos/ComboAbmGeoCiudades";
import ComboAbmZonPlantas from "../Compuestos/Combos/ComboAbmZonPlantas";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { LVGridCarga } from "../Basicos/LVGridCarga";
import { Column } from "devextreme-react/data-grid";
import { LVForm } from "../Basicos/LVForm";
import { function_ABM_EEX_Profesionales_Generar_JSON, function_ABM_EEX_Profesionales_Insertar, function_ABM_EEX_Profesionales_Leer, function_ABM_EEX_Profesionales_Modificar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Profesionales";

const ABM_EEX_Profesionales = (props) => {
  const [valorCodigoCuentaFinancieraParaComisiones, setValorCodigoCuentaFinancieraParaComisiones] = useState(null);
  const [valorCodigoTipoProfesional, setValorCodigoTipoProfesional] = useState(null);
  const [valorIdProveedor, setValorIdProveedor] = useState(null);
  const [valorIdPersona, setValorIdPersona] = useState(null);
  const [valorIdCiudad, setValorIdCiudad] = useState(1);
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [esMultiEmpresa, setEsMultiEmpresa] = useState(true);
  const [esMultiPlanta, setEsMultiPlanta] = useState(true);
  const [plantaSeleccionada, setPlantaSeleccionada] = useState(null);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

  const handleOnValueChangedMultiEmpresa = (e) => {
    const isChecked = e.value;

    setEsMultiEmpresa(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiEmpresa: isChecked
    }));
  };

  const handleOnValueChangedMultiPlanta = (e) => {
    const isChecked = e.value;

    setEsMultiPlanta(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiPlanta: isChecked
    }));
  };

  const handleOnClick_AgregarPlanta = async (e) => {
    if (!plantaSeleccionada.codigo) {
      alert("Seleccione una Planta antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const plantaYaExiste = datos.ListPlantas?.some(
      (planta) => planta.ABM_ZON_Plantas_CodigoPlanta === plantaSeleccionada.codigo
    );

    if (plantaYaExiste) {
      alert("La Planta ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaPlanta = {
      ABM_ZON_Plantas_CodigoPlanta: plantaSeleccionada.codigo,
      CodigoPlanta: plantaSeleccionada.codigo,
      Descripcion: plantaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListPlantas: [...(prevDatos.ListPlantas || []), nuevaPlanta],
    }));

    // Limpiar la selección después de agregar
    setPlantaSeleccionada(null);
  }

  const handleOnClick_AgregarEmpresa = async (e) => {
    if (!empresaSeleccionada.codigo) {
      alert("Seleccione una Empresa antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const empresaYaExiste = datos.ListEmpresas?.some(
      (empresa) => empresa.ABM_ZON_Empresas_CodigoEmpresa === empresaSeleccionada.codigo
    );

    if (empresaYaExiste) {
      alert("La Empresa ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaEmpresa = {
      ABM_ZON_Empresas_CodigoEmpresa: empresaSeleccionada.codigo,
      CodigoEmpresa: empresaSeleccionada.codigo,
      Descripcion: empresaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListEmpresas: [...(prevDatos.ListEmpresas || []), nuevaEmpresa],
    }));

    // Limpiar la selección después de agregar
    setEmpresaSeleccionada(null);
  }

  const handleOnClick_Guardar = async (e) => {
    try {

      if (!datos.RazonSocial || datos.RazonSocial.trim() === "") {
        datos.RazonSocial = `${datos.Nombre || ""} ${datos.Apellido || ""}`.trim();
      }

      if (datos.RazonSocial === "" && datos.Apellido === "" && datos.Nombre === "") {
        alert("Debe ser cargada la Razón Social o el Nombre y Apellido")
        return
      }

      if (datos.CUIT === "" || datos.CUIT === "0" || datos.CUIT === 0) {
        alert("Debe ser cargada la C.U.I.T. o el D.N.I.")
        return
      }

      if (!datos.IdCiudad || datos.IdCiudad === 0) {
        alert("Debe ser cargada la Ciudad de Residencia")
        return
      }

      if (!datos.CodigoTipoProfesional || datos.CodigoTipoProfesional === 0) {
        alert("Debe ser cargado el Tipo de Profesional")
        return
      }

      const JSON = await function_ABM_EEX_Profesionales_Generar_JSON(
        datos.IdProfesional,
        datos.MultiPlanta,
        datos.MultiEmpresa,
        datos.RazonSocial,
        datos.Apellido,
        datos.Nombre,
        datos.CUIT,
        datos.Calle,
        datos.Numero,
        datos.Piso,
        datos.Departamento,
        valorIdCiudad,
        datos.CodigoPostal,
        datos.Telefono1,
        datos.Telefono2,
        datos.Telefono3,
        datos.Telefono4,
        datos.Fax,
        datos.Email1,
        datos.Email2,
        datos.Web,
        datos.FechaAlta, //Date.now.setFullYear(1900).setMonth(1).setDay(1),
        datos.FechaBaja, //Date.now.setFullYear(1900).setMonth(1).setDay(1),
        datos.Zona1,
        datos.Zona2,
        datos.Zona3,
        datos.Exclusiones1,
        datos.Exclusiones2,
        datos.Exclusiones3,
        datos.Comision1,
        datos.Comision2,
        datos.Comision3,
        datos.Premios1,
        datos.Premios2,
        datos.Premios3,
        valorCodigoCuentaFinancieraParaComisiones,
        valorCodigoTipoProfesional,
        valorIdProveedor,
        datos.CUIT,
        datos.ValorVisita,
        datos.CUITCuenta,
        datos.CBU,
        datos.Banco,
        datos.TipoCuenta,
        datos.NroCuenta,
        datos.CBUResponsable,
        datos.ImporteViaticos,
        datos.ValorVisita2,
        datos.ValorVisita3,
        valorIdPersona,
        datos.ComisionSobreArticulos,
        datos.ListPlantas,
        datos.ListEmpresas
      )

      if (props.Codigo.Codigo === "--NUEVO--") {
        const Creado = await function_ABM_EEX_Profesionales_Insertar(JSON, false)
        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {
        const Modificado = await function_ABM_EEX_Profesionales_Modificar(JSON, false)
        alert("Se ha modificado el Código: " + datos.IdProfesional)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  useEffect(() => {
    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            IdProfesional: 0,
            MultiPlanta: true,
            MultiEmpresa: true,

            RazonSocial: '',
            Apellido: '',
            Nombre: '',
            CUIT: '',
            Calle: '',
            Numero: 0,
            Piso: 0,
            Departamento: '',
            IdCiudad: 1,
            CodigoPostal: '',
            Telefono1: '',
            Telefono2: '',
            Telefono3: '',
            Telefono4: '',
            Fax: '',
            Email1: '',
            Email2: '',
            Web: '',
            FechaAlta: '', //Date.now.setFullYear(1900).setMonth(1).setDay(1),
            FechaBaja: '', //Date.now.setFullYear(1900).setMonth(1).setDay(1),
            Zona1: '',
            Zona2: '',
            Zona3: '',
            Exclusiones1: '',
            Exclusiones2: '',
            Exclusiones3: '',
            Comision1: 0,
            Comision2: 0,
            Comision3: 0,
            Premios1: 0,
            Premios2: 0,
            Premios3: 0,
            CodigoCuentaFinancieraParaComisiones: '',
            CodigoTipoProfesional: '',
            IdProveedor: 0,
            DNI: 0,
            ValorVisita: 0,
            CUITCuenta: '',
            CBU: '',
            Banco: '',
            TipoCuenta: '',
            NroCuenta: '',
            CBUResponsable: '',
            ImporteViaticos: 0,
            ValorVisita2: 0,
            ValorVisita3: 0,
            IdPersona: 0,
            ComisionSobreArticulos: 0
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_EEX_Profesionales_Leer(props.Codigo.Codigo)
          setDatos(datosDocumento.data)

          setEsMultiPlanta(datosDocumento.data.MultiPlanta)
          setEsMultiEmpresa(datosDocumento.data.MultiEmpresa)

          setValorCodigoCuentaFinancieraParaComisiones(datosDocumento.data.CodigoCuentaFinancieraParaComisiones)
          setValorCodigoTipoProfesional(datosDocumento.data.CodigoTipoProfesional)
          setValorIdProveedor(datosDocumento.data.IdProveedor)
          setValorIdPersona(datosDocumento.data.IdPersona)
          //setValorIdCiudad(datosDocumento.data.IdCiudad)
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  const onValueChangedCodigoCuentaFinancieraParaComisiones = (e) => {
    setValorCodigoCuentaFinancieraParaComisiones(e.value)
    datos.CodigoCuentaFinancieraParaComisiones = e.value;
  }

  const onValueChangedCodigoTipoProfesional = (e) => {
    setValorCodigoTipoProfesional(e.value)
    datos.CodigoTipoProfesional = e.value;
  }

  const onValueChangedIdProveedor = (e) => {
    setValorIdProveedor(e.value)
    datos.IdProveedor = e.value;
  }

  const onValueChangedIdPersona = (e) => {
    setValorIdPersona(e.value)
    datos.IdPersona = e.value;
  }

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <TabbedItem>
        <TabPanelOptions deferRendering={false} />

        <Tab title="General" colCount={4}>
          <GroupItem caption="General">
            <SimpleItem dataField="IdProfesional" disabled={true} >
              <Label text="Código" />
            </SimpleItem>
            <SimpleItem dataField="RazonSocial">
              <Label text="Razón Social" />
            </SimpleItem>
            <SimpleItem dataField="Nombre">
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="Apellido">
              <Label text="Apellido" />
            </SimpleItem>
            <SimpleItem dataField="CUIT">
              <Label text="C.U.I.T." />
            </SimpleItem>
            <SimpleItem>
              <ComboAbmConCuentasFinancieras
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                IdTipoCuentaFinanciera={0}
                value={valorCodigoCuentaFinancieraParaComisiones}
                onValueChanged={onValueChangedCodigoCuentaFinancieraParaComisiones} />
            </SimpleItem>
            <SimpleItem>
              <ComboAbmEexProfesionalesTipos
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={valorCodigoTipoProfesional}
                onValueChanged={onValueChangedCodigoTipoProfesional} />
            </SimpleItem>
            <SimpleItem dataField="IdProveedor">
              <ComboAbmEexProveedores
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={valorIdProveedor}
                onValueChanged={onValueChangedIdProveedor} />
            </SimpleItem>
            <SimpleItem>
              <ComboAbmEexPersonas
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                value={valorIdPersona}
                onValueChanged={onValueChangedIdPersona} />
            </SimpleItem>
            <SimpleItem dataField="ValorVisita">
              <Label text="ValorVisita" />
            </SimpleItem>
            <SimpleItem dataField="ValorVisita2">
              <Label text="ValorVisita2" />
            </SimpleItem>
            <SimpleItem dataField="ValorVisita3">
              <Label text="ValorVisita3" />
            </SimpleItem>
            <SimpleItem dataField="ImporteViaticos">
              <Label text="ImporteViaticos" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Contacto">
            <SimpleItem dataField="Calle">
              <Label text="Calle" />
            </SimpleItem>
            <SimpleItem dataField="Numero">
              <Label text="Numero" />
            </SimpleItem>
            <SimpleItem dataField="Piso">
              <Label text="Piso" />
            </SimpleItem>
            <SimpleItem dataField="Departamento">
              <Label text="Departamento" />
            </SimpleItem>
            <SimpleItem dataField="CodigoPostal">
              <Label text="CodigoPostal" />
            </SimpleItem>
            <SimpleItem dataField="Telefono1">
              <Label text="Telefono1" />
            </SimpleItem>
            <SimpleItem dataField="Telefono2">
              <Label text="Telefono2" />
            </SimpleItem>
            <SimpleItem dataField="Telefono3">
              <Label text="Telefono3" />
            </SimpleItem>
            <SimpleItem dataField="Telefono4">
              <Label text="Telefono4" />
            </SimpleItem>
            <SimpleItem dataField="Fax">
              <Label text="Fax" />
            </SimpleItem>
            <SimpleItem dataField="Email1">
              <Label text="Email1" />
            </SimpleItem>
            <SimpleItem dataField="Email2">
              <Label text="Email2" />
            </SimpleItem>
            <SimpleItem dataField="Web">
              <Label text="Web" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Banco">
            <SimpleItem dataField="Banco">
              <Label text="Banco" />
            </SimpleItem>
            <SimpleItem dataField="TipoCuenta">
              <Label text="Tipo de Cuenta" />
            </SimpleItem>
            <SimpleItem dataField="CBU">
              <Label text="C.B.U." />
            </SimpleItem>
            <SimpleItem dataField="NroCuenta">
              <Label text="Nº Cuenta" />
            </SimpleItem>
            <SimpleItem dataField="CUITCuenta">
              <Label text="C.U.I.T. de Cuenta" />
            </SimpleItem>
            <SimpleItem dataField="CBUResponsable">
              <Label text="C.B.U. del Responsable" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Comisiones">
            <SimpleItem dataField="Zona1">
              <Label text="Zona 1" />
            </SimpleItem>
            <SimpleItem dataField="Zona2">
              <Label text="Zona 2" />
            </SimpleItem>
            <SimpleItem dataField="Zona3">
              <Label text="Zona 3" />
            </SimpleItem>
            <SimpleItem dataField="Exclusiones1">
              <Label text="Exclusiones 1" />
            </SimpleItem>
            <SimpleItem dataField="Exclusiones2">
              <Label text="Exclusiones 2" />
            </SimpleItem>
            <SimpleItem dataField="Exclusiones3">
              <Label text="Exclusiones 3" />
            </SimpleItem>
            <SimpleItem dataField="Comision1">
              <Label text="Comisión 1" />
            </SimpleItem>
            <SimpleItem dataField="Comision2">
              <Label text="Comisión 2" />
            </SimpleItem>
            <SimpleItem dataField="Comision3">
              <Label text="Comisión 3" />
            </SimpleItem>
            <SimpleItem dataField="Premios1">
              <Label text="Premios 1" />
            </SimpleItem>
            <SimpleItem dataField="Premios2">
              <Label text="Premios 2" />
            </SimpleItem>
            <SimpleItem dataField="Premios3">
              <Label text="Premios 3" />
            </SimpleItem>
            <SimpleItem dataField="ComisionSobreArticulos">
              <Label text="Comisión sobre Artículos" />
            </SimpleItem>
          </GroupItem>
        </Tab>

        <Tab title="Plantas">
          <GroupItem>
            <SimpleItem dataField="MultiPlanta" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiPlanta(e) }}>
              <Label text="MultiPlanta (Desactivado permite definir para que Plantas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiPlanta}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonPlantas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setPlantaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR PLANTA"} onClick={handleOnClick_AgregarPlanta} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListPlantas}
              keyExpr="ABM_ZON_Plantas_CodigoPlanta"
            >
              <Column caption="Código" dataField="ABM_ZON_Plantas_CodigoPlanta" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Empresas">
          <GroupItem>
            <SimpleItem dataField="MultiEmpresa" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiEmpresa(e) }}>
              <Label text="MultiEmpresa (Desactivado permite definir para que Empresas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiEmpresa}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonEmpresas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setEmpresaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR EMPRESA"} onClick={handleOnClick_AgregarEmpresa} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListEmpresas}
              keyExpr="ABM_ZON_Empresas_CodigoEmpresa"
            >
              <Column caption="Código" dataField="ABM_ZON_Empresas_CodigoEmpresa" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>
      </TabbedItem>

      <ButtonItem horizontalAlignment="Center" colSpan={4}>
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_EEX_Profesionales;